
import { Box, } from "@mui/material"
import { QuestionForm } from "./questionForm"
import { Answer } from "./answer"
const Question = () => {
    return (
        <Box >
            <QuestionForm />

            <Answer />
        </Box>
    )
}

export { Question }
